module.exports = __webpack_public_path__ + "static/joe-text-d478dbe22ebd10e8d94035f4ef170966.svg";